import { useState } from "react";

const EmojiRow = ({ showUi, content, rowId, respond }) => {

  const [textInput, setTextInput] = useState(null)

  const handleChange = (e) => {
    setTextInput(e.target.value)
  }

  let response;
  if (content.responses) {
    response = content.responses.map((emoji, index) => {

      // I think this logic belongs in api. It should either send the emoji character, or the UTF hex code
      // I found the codes at https://www.w3schools.com/charsets/ref_emoji_smileys.asp

      /* no longer in use - decided svgs more suited to the matterjs integration
      let charHex = '\u231B';
      switch(emoji.text){
        case 'smile':
          charHex = '\u{1F600}'; break;
        case 'sad':
          charHex = '\u{1F622}'; break;
        case 'angry':
          charHex = '\u{1F621}'; break;
        case 'confused':
          charHex = '\u{1F615}'; break;
        case 'tired':
          charHex = '\u{1F62B}'; break;
        }
        */

      return <button
        key={index}
        className={`mr-2 emoji ${emoji.text}`}
        onClick={() => respond(rowId, emoji.text, null, content.text)}>
      </button>
    }

    );
  } else {
    response = <div className="flex w-full items-end justify-between pt-2 md:pt-8">
      <textarea
        className="
              w-full
              px-3
              py-1.5
              text-xs
              md:text-base
              font-normal
              text-nitro-slate
              bg-white bg-clip-padding
              rounded
              transition
              ease-in-out
              focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
            "
        id="Textarea1"
        rows="2"
        placeholder="Type here"
        onChange={handleChange}
      ></textarea>
      <button className="shrink-0 ml-2 emoji_send_btn" onClick={() => respond(rowId, 'send', textInput, content.text)}></button>
    </div>;
  }

  let responseClass = 'emoji_response';
  responseClass += (showUi)?' ':' disable';

  return (
    <div className="emoji_bubble" key={rowId}>
      <div className="emoji_text">{content.text}</div>
      <div className={responseClass}>{response}</div>
    </div>
  );
}

export default EmojiRow;
